import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Tag } from 'src/app/models/tag';

@Injectable({ providedIn: 'root' })
export class TagResourceService {
    private baseUrl: string;

    constructor(
        configService: ConfigService,
        private http: HttpClient,
        private routingHelpersService: RoutingHelpersService
    ) {
        this.baseUrl = routingHelpersService.combineUrl(
            configService.apiUrl.rideCommand,
            'tag'
        );
    }

    get(parent: string): Observable<Tag[]> {
        const url = this.routingHelpersService.combineUrl(this.baseUrl, parent);
        return this.http
            .get(url, {
                params: {
                    skipAuthorization: true,
                },
            })
            .pipe(
                catchError(() => of([])),
                map((tagDtos: unknown[]) =>
                    (tagDtos || []).map((dto) => Tag.create(dto))
                )
            );
    }
}
